<template>
  <div>
    <el-dialog
      width="30%"
      :before-close="handleClose"
      :visible.sync="mydialogFormVisible"
    >
      <div
        slot="title"
        class="header-title"
        :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
      >
        <div>{{ title }}</div>
      </div>
      <el-form
        :model="myform"
        ref="myform"
        :validate-on-rule-change="false"
        :rules="rules"
      >
        <el-form-item :label="label[0] + ':'" label-width="90px" prop="one">
          <el-input
            v-model="myform.one"
            placeholder="必填，2-10个字"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isLib" label="父级图库" label-width="90px">
          <el-select
            style="width: 100%"
            filterable
            :filter-method="remoteMethod"
            v-model="libFather"
            placeholder="选填"
          >
            <el-option
              v-for="item in libFatherList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="label[1] + ':'" label-width="90px" prop="two">
          <el-input
            v-model="myform.two"
            placeholder="必填，数字越大越靠前"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quit">取 消</el-button>
        <el-button
          v-if="!isClick"
          :style="{
            border: 'none',
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          type="primary"
          @click="submit('myform')"
          >提 交</el-button
        >
        <el-button
          v-else
          type="primary"
          :style="{
            border: 'none',
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          disabled
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { updateAuthRole } from "@/api/authRole";
import { listLib } from "@/api/lib";
export default {
  props: {
    title: {
      type: String,
      default: "编辑",
    },
    myform: Object,
    // rules:Object,
    dialogFormVisible: Boolean,
    label: Array,

    isLib: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogFormVisible: {
      deep: true,
      handler(v) {
        this.mydialogFormVisible = v;
      },
    },
  },
  data() {
    return {
      isClick: false,

      libFatherList: [],
      libFather: "",

      mydialogFormVisible: this.dialogFormVisible,
      rules: {
        one: [
          { required: true, message: "请输入内容", trigger: "change" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        two: [{ required: true, message: "请输入内容", trigger: "change" }],
      },
    };
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),
    handleClose() {
      this.libFather = "";
      this.$refs["myform"].clearValidate();
      this.mydialogFormVisible = false;
      this.$emit("changedialogFormVisible", this.mydialogFormVisible);
      this.setDialogFormVisible(false);
      this.listLibAsync({
        page: 0,
        parentId: 0,
        pageSize: 20,
      });
    },
    quit() {
      this.libFather = "";
      this.$refs["myform"].clearValidate();
      this.mydialogFormVisible = false;
      this.$emit("changedialogFormVisible", this.mydialogFormVisible);
      this.setDialogFormVisible(false);
      this.listLibAsync({
        page: 0,
        parentId: 0,
        pageSize: 20,
      });
    },
    submit(myform) {
      this.$refs[myform].validate((valid) => {
        if (valid) {
          this.$confirm("是否确定提交?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            confirmButtonClass: this.isCustom
              ? this.custom == "xugong"
                ? "xgfirm"
                : "wcfirm"
              : this.isSimple
              ? "mySimplePriConfirm"
              : "myPriConfirm", //点击删除
          })
            .then(() => {
              this.isClick = true;
              setTimeout(() => {
                this.isClick = false;
              }, 2000);
              
              if (this.title === "修改角色") {
                let willToPushData = {
                  name: this.myform.one,
                  sort: this.myform.two,
                  type: 0,
                  id: this.myform.id,
                };
                this.updateAuthRoleAsync(willToPushData);
              } else {
                this.$emit("dialogSubmit", this.myform, this.libFather);
              }
              this.mydialogFormVisible = false;
              this.$emit("changedialogFormVisible", this.mydialogFormVisible);
              this.setDialogFormVisible(false);
              setTimeout(() => {
                this.libFather = "";
                this.listLibAsync({
                  page: 0,
                  parentId: 0,
                  pageSize: 20,
                });
              }, 500);
              this.$refs.myform.resetFields();
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消'
              // });
            });
        } else {
          this.$message({
            type: "info",
            message: "请正确填写！",
          });
          return false;
        }
      });
    },
    changeX(e) {
      // console.log(e)
      this.$forceUpdate();
    },

    remoteMethod(query) {
      if (query !== "") {
        this.listLibAsync({
          page: 0,
          pageSize: 20,
          parentId: 0,
          keyword: query,
        });
      } else {
        this.listLibAsync({
          page: 0,
          parentId: 0,
          pageSize: 20,
        });
      }
    },

    //获取图片库列表
    async listLibAsync(val) {
      let { status, data, message, pagination, errors } = await listLib(val);
      this.libFatherList = [];

      for (let i = 0; i < data.length; i++) {
        this.libFatherList.push({
          label: data[i].name,
          value: data[i].id,
        });
      }
    },

    //修改角色信息
    async updateAuthRoleAsync(val) {
      let { status, data, message, errors } = await updateAuthRole(val);
      if (status) {
        // this.mydialogVisible = false;
        this.$message.success("修改成功！");
        this.mydialogFormVisible = false;
        this.setDialogFormVisible(false);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created() {
    console.log(111);
    // this.listLibAsync();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
/deep/ .el-form-item__label {
  font-weight: 600;
}
</style>